import MiniLogo from '@assets/icons/tarumt-icon.svg';
import moment from 'moment';
import './styles.css';

const Footer = () => {
	return (
		<div className="footer">
			<div className="footer-container">
				<div className="footer-contact">
					<h2>Contact Us</h2>
					<div className="footer-contact-info">
						<div style={{ fontWeight: 700 }}>
							TARCian Alumni Association (PPM-012-14-03022012 (0351-12-WKL))
						</div>
						<div>☎️ : +6011-5589 5238</div>
						<div>📧 : admin@tarcalumni.my</div>
						<div>
							🏠 : Block E-2-6 Plaza Damas, 60, Jalan Sri Hartamas 1, Sri Hartamas, 50480 Kuala
							Lumpur.
						</div>
					</div>
				</div>
			</div>

			<div className="footer-copyright">
				<div>© {moment().format('YYYY')} TARCian Alumni Association</div>
			</div>
		</div>
	);
};

export default Footer;
